import type { ProcessingStatus } from "@cdt/shared";

import { Badge } from "@/components/ui/badge";

type Variant = "green" | "yellow" | "red" | "gray" | "blue";

const VARIANT_BY_STATUS: Record<ProcessingStatus, Variant> = {
  CREATED: "green",
  MANUAL_REVIEW: "yellow",
  ERROR: "red",
  IGNORED: "gray",
  PENDING: "blue",
};

const LABEL_BY_STATUS: Record<ProcessingStatus, string> = {
  CREATED: "Creato",
  MANUAL_REVIEW: "Revisione",
  ERROR: "Errore",
  IGNORED: "Ignorato",
  PENDING: "In attesa",
};

export const STATUS_LIST: ProcessingStatus[] = [
  "CREATED",
  "MANUAL_REVIEW",
  "PENDING",
  "ERROR",
  "IGNORED",
];

export function statusVariant(status: ProcessingStatus): Variant {
  return VARIANT_BY_STATUS[status];
}

export function statusLabel(status: ProcessingStatus): string {
  return LABEL_BY_STATUS[status];
}

export function StatusBadge({ status }: { status: ProcessingStatus }) {
  return <Badge variant={statusVariant(status)}>{statusLabel(status)}</Badge>;
}
